import clsx from 'clsx';

import { LoadingPosition } from './LoadingComponent';

interface Props {
  contextClassName?: string;
  modifierClassName?: string;
  'data-testid'?: string;
  position?: LoadingPosition;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
const BallPulse = ({ contextClassName, modifierClassName, position = 'FIXED', ...rest }: Props) => {
  const classNames = clsx(
    'BallPulse',
    {
      'BallPulse--inline': position === 'INLINE' || position === 'INLINE-FULL',
    },
    modifierClassName
  );

  const internalContextClassName = clsx(contextClassName, {
    'BallPulse--inline-fullScreen': position === 'INLINE-FULL',
  });

  return (
    <div className={internalContextClassName}>
      <div className={classNames} data-testid={rest['data-testid']}>
        <div className="BallPulse-dot" />
        <div className="BallPulse-dot" />
        <div className="BallPulse-dot" />
      </div>
    </div>
  );
};

export default BallPulse;
